import { render } from "./NuevaReserva.vue?vue&type=template&id=46f6c117&scoped=true"
import script from "./NuevaReserva.vue?vue&type=script&lang=js"
export * from "./NuevaReserva.vue?vue&type=script&lang=js"

import "./NuevaReserva.vue?vue&type=style&index=0&id=46f6c117&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46f6c117"]])

export default __exports__